<template>
  <div id="News">
    <div class="News_main">
      <div class="News_title">{{ item.title }}</div>
      <div class="News_time">{{ item.startTime }}</div>
      <div class="News_index" v-html="item.dataes"></div>
    </div>
  </div>
</template>

<script>
import { findNewDetail } from "../axiosAPI";
export default {
  name: "News",
  data() {
    return {
      item: "",
    };
  },
  mounted() {
    this.getNewDetail();
  },
  methods: {
    getNewDetail() {
      let query = this.$qs.stringify({
        id: this.$route.query.id,
      });
      findNewDetail(query).then((res) => {
        if (res.data.code == 200) {
          if (res.data.item) {
            this.item = res.data.item;
          } else {
            this.$router.push({ path: "/" });
            this.$message({
              type: "error",
              message: "系统错误!请稍后再试!",
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
#News {
  width: 100%;
  .News_main {
    // display: flex;
    padding: 0.2rem;
    .News_title {
      // height: 1rem;
      // line-height: 1rem;
      padding-top: 0.2rem;
      font-size: 0.3rem;
      text-align: center;
    }
    .News_time {
      font-size: 0.2rem;
      padding: 0.2rem 0;
      text-align: center;
      border-bottom: 3px solid #ee9578;
    }
    .News_index {
      padding: 0.5rem 0;
      text-indent: 2em;
      font-size: 0.25rem;
    }
  }
}
</style>
